export default "__VITE_ASSET__DEkte3Il__";